exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/course-v2.js-WebpackMultiOutput";